import {useRef} from 'react';
import useIsomorphicEffect from 'src/internal/useIsomorphicEffect';

/**
 * Declarative hook to monitor the changes of a list of dependencies.
 *
 * @example Basic {{include "./examples/useUpdateEffect.basic.tsx"}}
 *
 * @see https://sail.stripe.me/apis/react/useUpdateEffect
 */
export default function useUpdateEffect(
  /** The callback to execute when a change is detected. */
  callback: () => void,
  /** The list of dependencies to monitor for changes. */
  deps: unknown[],
): void {
  const init = useRef(false);

  useIsomorphicEffect(() => {
    if (init.current) {
      callback();
    }
    init.current = true;
  }, deps);
}
